/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Feedback_PostInputs */

const en_a11y_statement_feedback_post = /** @type {(inputs: A11y_Statement_Feedback_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postal address: EliteX GbR, Koppoldstr. 1, 86551 Aichach, Germany`)
};

const de_a11y_statement_feedback_post = /** @type {(inputs: A11y_Statement_Feedback_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postanschrift: EliteX GbR, Koppoldstr. 1, 86551 Aichach, Deutschland`)
};

const fr_a11y_statement_feedback_post = /** @type {(inputs: A11y_Statement_Feedback_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse postale : EliteX GbR, Koppoldstr. 1, 86551 Aichach, Allemagne`)
};

const es_a11y_statement_feedback_post = /** @type {(inputs: A11y_Statement_Feedback_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direccion postal: EliteX GbR, Koppoldstr. 1, 86551 Aichach, Alemania`)
};

const it_a11y_statement_feedback_post = /** @type {(inputs: A11y_Statement_Feedback_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indirizzo postale: EliteX GbR, Koppoldstr. 1, 86551 Aichach, Germania`)
};

const nl_a11y_statement_feedback_post = /** @type {(inputs: A11y_Statement_Feedback_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postadres: EliteX GbR, Koppoldstr. 1, 86551 Aichach, Duitsland`)
};

const pl_a11y_statement_feedback_post = /** @type {(inputs: A11y_Statement_Feedback_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adres pocztowy: EliteX GbR, Koppoldstr. 1, 86551 Aichach, Niemcy`)
};

const fi_a11y_statement_feedback_post = /** @type {(inputs: A11y_Statement_Feedback_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postiosoite: EliteX GbR, Koppoldstr. 1, 86551 Aichach, Saksa`)
};

const da_a11y_statement_feedback_post = /** @type {(inputs: A11y_Statement_Feedback_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postadresse: EliteX GbR, Koppoldstr. 1, 86551 Aichach, Tyskland`)
};

const sv_a11y_statement_feedback_post = /** @type {(inputs: A11y_Statement_Feedback_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postadress: EliteX GbR, Koppoldstr. 1, 86551 Aichach, Tyskland`)
};

/**
* | output |
* | --- |
* | "Postal address: EliteX GbR, Koppoldstr. 1, 86551 Aichach, Germany" |
*
* @param {A11y_Statement_Feedback_PostInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_feedback_post = /** @type {((inputs?: A11y_Statement_Feedback_PostInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Feedback_PostInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_feedback_post(inputs)
	if (locale === "fr") return fr_a11y_statement_feedback_post(inputs)
	if (locale === "es") return es_a11y_statement_feedback_post(inputs)
	if (locale === "it") return it_a11y_statement_feedback_post(inputs)
	if (locale === "nl") return nl_a11y_statement_feedback_post(inputs)
	if (locale === "pl") return pl_a11y_statement_feedback_post(inputs)
	if (locale === "fi") return fi_a11y_statement_feedback_post(inputs)
	if (locale === "da") return da_a11y_statement_feedback_post(inputs)
	if (locale === "sv") return sv_a11y_statement_feedback_post(inputs)
	return en_a11y_statement_feedback_post(inputs)
});